export * from './machine-needle-mapping-enum';